import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from '../state.service';
import { AlertService } from '../alert.service';
import { ToastService } from '../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';

import { AuthService } from '../auth.service';

// const SENSOR_API_URL = `https://test-logs-sensor-api.cdc-iot.com`;
const SENSOR_API_URL = `https://logs-sensor-api.cdc-iot.com`;
// -- 2024/08/12 09:00までのデータは、以下のURLで参照可能なため向き先を変更する
const SENSOR_LOG_TO_20240812_URL = 'https://search-to-20240812-logs-sensor-api.cdc-iot.com';
// -- 2025/12/01 21:00までのデータは、以下のURLで参照可能なため向き先を変更する
const SENSOR_LOG_TO_20251201_URL = 'https://search-to-20251201-logs-sensor-api.cdc-iot.com';

@Injectable()
export class ApiDebugService extends ApiBaseService {

  protected headers: Headers;
  isLoading: boolean = true;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
    public authService: AuthService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }

  getSensorApi(targetTime: number): string {
    // 2024/08/12 09:00より以前のデータは、別のURLでデータを参照する
    if (targetTime <= 1723420800) {
      return SENSOR_LOG_TO_20240812_URL;
    } else if (targetTime <= 1764592200) {
      return SENSOR_LOG_TO_20251201_URL;
    }
    return SENSOR_API_URL;
  }


  getDebugHeader() {
    return new Headers({
      'Accept': 'application/json',
      'Content-type': 'application/json',
      'Accept-Language': 'ja,en-US;q=0.9,en;q=0.8',
      // 'app-uuid': '',
      // 'app-view': '',
      // 'current-app-version': VERSION_CONFIG.CURRENT_VIESION,
      // 'current-app-small-version': VERSION_CONFIG.CURRENT_SMALL_VIESION,
      'x-api-key': 'XXXXXXX_5e3776abf3f4cae4465c8c9a',
      'x-api-secret': 'a68797235d884859bdadd5af4dd32627',
    });
  }


  getDebugSensorLogs(params: any = {}): Promise<any> {
    params.contractGroupId = this.authService.user.contractGroupId;
    // params.contractId = this.authService.user.contractId;
    let queryString = this.getQueryString(params);
    const TARGET_SENSOR_URL = this.getSensorApi(params.start);
    // let url = `${this.apiAuthStore.url}/api/v1/debugLogs?${queryString}`;
    const url = `${TARGET_SENSOR_URL}/api/cdc/debugLogs?${queryString}`;


    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.getDebugHeader()}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }


  getDebugSensorDetailLogs(_id): Promise<any> {
    // let url = `${this.apiAuthStore.url}/api/v1/debugLogs/${_id}`;

    const url = `${SENSOR_API_URL}/api/cdc/debugLogs/${_id}`;

    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.getDebugHeader()}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }


  /**
   * 睡眠センサーの生データを取得する
   */
  async getSleepSensorLogs(params: any = {}): Promise<any> {
    params.contractGroupId = this.authService.user.contractGroupId;
    // params.contractId = this.authService.user.contractId;
    let queryString = this.getQueryString(params);
    const TARGET_SENSOR_URL = this.getSensorApi(params.start);
    const url = `${TARGET_SENSOR_URL}/api/cdc/sleepLogs?${queryString}`;

    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.getDebugHeader()}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }


  /**
   * 睡眠センサーの生データを取得する
   */
  async getSleepAlertLogs(params: any = {}): Promise<any> {
    params.contractGroupId = this.authService.user.contractGroupId;
    // params.contractId = this.authService.user.contractId;
    let queryString = this.getQueryString(params);
    const TARGET_SENSOR_URL = this.getSensorApi(params.start);
    const url = `${TARGET_SENSOR_URL}/api/cdc/sleepAlertLogs?${queryString}`;

    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.getDebugHeader()}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  async getVitalBWLogs(params: any = {}): Promise<any> {
    params.contractGroupId = this.authService.user.contractGroupId;
    // params.contractId = this.authService.user.contractId;
    let queryString = this.getQueryString(params);
    const TARGET_SENSOR_URL = this.getSensorApi(params.start);
    const url = `${TARGET_SENSOR_URL}/api/cdc/vitalBWLogs?${queryString}`;

    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.getDebugHeader()}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  async getReportLogs(params: any = {}): Promise<any> {
    params.contractGroupId = this.authService.user.contractGroupId;
    // params.contractId = this.authService.user.contractId;
    let queryString = this.getQueryString(params);
    const TARGET_SENSOR_URL = this.getSensorApi(params.start);
    const url = `${TARGET_SENSOR_URL}/api/cdc/reportLogs?${queryString}`;

    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.getDebugHeader()
      }
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }
  /**
   * ナースコールの履歴を取得する
   */
  async getNurseCallLogs(params: any = {}): Promise<any> {
    params.contractGroupId = this.authService.user.contractGroupId;
    // params.contractId = this.authService.user.contractId;
    let queryString = this.getQueryString(params);
    const TARGET_SENSOR_URL = this.getSensorApi(params.start);
    const url = `${TARGET_SENSOR_URL}/api/cdc/nurseCallLogs?${queryString}`;

    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.getDebugHeader()}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-debug.service.ts